import {
  LabraToolTipV2,
  OfferCard,
  VerticalDivider,
} from '@labrav/react-components'
import { useTimeZone } from '../../../common/utils/hooks/useTimeZone'
import { dateAndTimeConversion } from '../../../common/utils/dateAndTimeConversion'
import { useStyles } from './UpcomingRenewals.styles'
import { Avatar } from '@mui/material'
import { getCloudImg } from '../../../common/utils/getCloudImg'
import renwalOff from '../../../common/images/renewalOff.svg'
import {
  numberFormat,
  resolveBuyerLogoUrl,
  useAccountId,
  useCurrentCloudProvider,
} from '@labrav/common'
import { Overview } from '../../../modules/flyoutOverview/types'
import { useSelector } from '../../../store/hooks'
import { OverviewEmptyState } from '../OverviewEmptyState/OverviewEmptyState'
import { useNavigate, useParams } from 'react-router-dom'
import OverviewEmptyStateImage from '../../../common/images/overviewEmptyState.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRepeat } from '@fortawesome/pro-regular-svg-icons'

export const UpcomingRenewals = () => {
  const { timeZone } = useTimeZone()
  const { classes } = useStyles()
  const navigate = useNavigate()
  const { cloud: routeCloud, accountId: routeAccountId } = useParams<{
    cloud?: string
    accountId?: string
  }>()
  const defaultAccountId = useAccountId({ product: 'flyout' }) || ''
  const accountId = routeAccountId || defaultAccountId
  const selectedCloud = useCurrentCloudProvider()
  const goToSubscriptionsDetail = (subscriptionId: string) => {
    const cloudPath = routeCloud?.toLowerCase() || selectedCloud.toLowerCase()
    const subscriptionDetailPath =
      routeCloud && accountId
        ? `/flyout/${cloudPath}/${accountId}/subscriptions/${subscriptionId}/detail`
        : `/flyout/subscriptions/${subscriptionId}/detail`
    navigate(subscriptionDetailPath)
  }
  const { upcomingRenewals } = useSelector<Overview>(
    state => state.flyoutOverview?.overview
  )
  const isUpcomingRenewalsDataEmpty =
    !upcomingRenewals || upcomingRenewals.length === 0

  return (
    <>
      {isUpcomingRenewalsDataEmpty ? (
        <OverviewEmptyState
          imgUrl={OverviewEmptyStateImage}
          containerHeight={36.25}
          imageHeight={12}
          imageWidth={16.75}
          description="You have no upcoming renewals currently."
        />
      ) : (
        <div className={classes.root} data-testid={'upcoming-renewal'}>
          {upcomingRenewals?.map((offerItem, index) => {
            const isLastRow = index === upcomingRenewals?.length - 1
            const { modifiedDate } = dateAndTimeConversion(
              offerItem?.expiryDate,
              timeZone
            )
            const descriptionSection = (
              <div
                className={classes.description}
                data-testid={'card-description'}
              >
                <span className={classes.offerExpiration}>
                  Due by {modifiedDate}{' '}
                </span>
                <VerticalDivider height="16px" />
                <span className={classes.tcvText}>
                  TCV: USD{' '}
                  {offerItem?.tcv ? numberFormat(offerItem?.tcv) : 'NA'}
                </span>
              </div>
            )
            const rightSection = (
              <>
                {offerItem?.salesBy && (
                  <>
                    <LabraToolTipV2
                      description={`Sales rep: ${offerItem?.salesBy}`}
                      tooltipPlacement="bottom"
                      tooltipPlacmentGap="-5"
                    >
                      <Avatar
                        className={classes.avatar}
                        data-testid={'sales-avatar'}
                      >
                        {offerItem?.salesBy?.charAt(0).toUpperCase()}
                      </Avatar>
                    </LabraToolTipV2>
                  </>
                )}
                <img
                  src={getCloudImg(offerItem?.cloud)}
                  data-testid={`icon1-${1}`}
                  style={{ width: '24px', height: '24px' }}
                  alt=""
                />

                <LabraToolTipV2
                  description={
                    offerItem?.autoRenewal
                      ? 'Auto-renewal is active.'
                      : 'Auto-renewal is off.'
                  }
                  tooltipPlacement="bottom"
                  tooltipPlacmentGap="-5"
                >
                  {offerItem?.autoRenewal ? (
                    <FontAwesomeIcon
                      icon={faRepeat}
                      className={classes.renewalIcon}
                      data-testid={'renewal-icon'}
                    />
                  ) : (
                    <img
                      src={renwalOff}
                      data-testid={'renewal-icon'}
                      className={classes.renewalOffIcon}
                      alt=""
                    />
                  )}
                </LabraToolTipV2>
              </>
            )
            return (
              <div
                key={offerItem.id || index}
                className={isLastRow ? classes.lastRow : ''}
                data-testid={'offer-card-row'}
              >
                <OfferCard
                  logoTooltip={offerItem?.companyName}
                  name={offerItem?.offerName}
                  onArrowClick={() =>
                    offerItem?.subscriptionId &&
                    goToSubscriptionsDetail(offerItem.subscriptionId)
                  }
                  logo={resolveBuyerLogoUrl(offerItem?.companyLogo)}
                  description={descriptionSection}
                  rightSideSection={rightSection}
                  actionTooltip="View contract details"
                  isLastCard={isLastRow}
                />
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}
